export default "/images/gizmorilla_eu.svg?652456b76c87d8b2a3783d05357ea4c9";